import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { totalRowRatio } from '../../../../../react-table/helpers/rowTotals';
import DirectionTypes from '../../../../../common/redux/actions/types/DirectionTypes';

export const getDetailsTabNavOptions = direction => rowInfo => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PAPER_FREE_MONITORING_POST_902_DETAILS.id,
    mainReportId: ReportDefinitions.PAPER_FREE_MONITORING_POST_902_SUMMARY.id,
    requestParams: {
      operator: rowInfo.row.operator,
      direction,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {}
);

export const globalScoreConditionalProps = (state, rowInfo) => {
  if (rowInfo) {
    const { row } = rowInfo;
    if (row.globalScore === null) {
      row.globalScore = '-';
    }
  }
  return {
  };
};

export const carrierScoreConditionalProps = (state, rowInfo) => {
  if (rowInfo) {
    const { row } = rowInfo;
    if (row.carrierScore === null) {
      row.carrierScore = '-';
    }
  }
  return {
  };
};

export default (data) => {
  const {
    TextColumn,
    NonZeroPercentageColumn,
    NavigationWithFooterWithZeroPercentageColumn,
    PercentageColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Operator', 'operator').withTotalHeader('Total').withWidth(180),
        new PercentageColumn('Global score', 'globalScore').withGetProps(globalScoreConditionalProps).withTotalHeader(totalRowRatio(['globalScorePfVolume', 'globalScoreVolume'])).withWidth(180),
        new NonZeroPercentageColumn('', 'globalScoreVolume').withShow(false),
        new NonZeroPercentageColumn('', 'globalScorePfVolume').withShow(false),
        new NavigationWithFooterWithZeroPercentageColumn(new NonZeroPercentageColumn('Carrier score', 'carrierScore').withGetProps(carrierScoreConditionalProps).withTotalHeader(totalRowRatio(['carrierScorePfVolume', 'carrierScoreVolume'])).withWidth(180), getDetailsTabNavOptions(DirectionTypes.INBOUND)),
        new NonZeroPercentageColumn('', 'carrierScoreVolume').withShow(false),
        new NonZeroPercentageColumn('', 'carrierScorePfVolume').withShow(false),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.PAPER_FREE_MONITORING_POST_902_DETAILS.id,
        mainReportId: ReportDefinitions.PAPER_FREE_MONITORING_POST_902_SUMMARY.id,
        requestParams: {
          isTotal: true,
          operator: '*',
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
